import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";

const PdfViewer = () => {
  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("pdf.baomat");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src="/uploads/GoPaperless_ChínhSáchBảoMậtThôngTin.pdf"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="GoPaperless_ChinhSachBaoMatThongTin"
      ></iframe>
    </div>
  );
};

export default PdfViewer;
